import {
  terracotta,
  offWhite,
  grey,
  bannerBackground,
  boxShadowCard,
} from "Constants/ColourConstants";

const statusTextBase = {
  width: "100%",
  textAlign: "right",
  fontWeight: "bold",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const rightCardStackBase = {
  width: "100%",
  maxWidth: "650px",
  minWidth: { xs: "325px", lg: "650px" },
};

export const styles = {
  container: {
    backgroundColor: offWhite,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingTop: 2,
    px: { xs: 2, sm: 4, md: 10 },
  },
  availableAppointmentsPaper: {
    boxSizing: "border-box",
    overflowX: "hidden",
    width: "100%",
    maxWidth: "100%",
    padding: "1rem",
    borderRadius: 2,
    marginBottom: "1rem",
    my: "0.5rem",
  },
  truncatedText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },

  // Confirm Delete Modal Styles
  loadingBackdrop: {
    color: "primary.main",
    zIndex: 2000,
  },
  // Clinic Card Styles
  clinicCard: {
    width: "100%",
    boxSizing: "border-box",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    "&.MuiPaper-root": { p: 2 },
  },
  timeSlotGrid: {
    ...rightCardStackBase,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: { xs: "center", sm: "flex-end" },
    alignItems: "flex-start",
    gap: 1,
  },
  clinicName: {
    fontSize: 16,
    fontWeight: "bold",
    color: "primary.main",
    textAlign: "left",
  },
  availabilityText: {
    ...statusTextBase,
    fontSize: { xs: 16, md: 18 },
    textAlign: { xs: "center", sm: "right" },
    color: "secondary.main",
  },
  rightCardStackBase,
  importantNoteHeader: {
    ...statusTextBase,
    fontSize: 14,
    color: "primary.main",
  },
  bannerInfoIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
  banner: {
    backgroundColor: bannerBackground,
    pr: 1,
    py: 0,
    textAlign: "left",
  },

  //Upcoming Appointments Styles
  upcomingPastAppointmentFooterBox: {
    backgroundColor: offWhite,
    width: "100%",
    padding: "1rem",
    textAlign: "center",
  },
  upcomingPastAppointmentNote: {
    fontSize: 14,
    color: grey,
  },
  upcomingPastAppointmentPaper: {
    backgroundColor: "white",
    padding: 2,
    width: "95%",
    border: `2px solid ${terracotta}`,
    borderTop: "none",
    position: "relative",
    boxShadow: boxShadowCard,
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-2px",
      left: "1px",
      height: "2px",
      width: "5%",
      backgroundColor: terracotta,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-2px",
      right: "1px",
      height: "2px",
      width: "5%",
      backgroundColor: terracotta,
    },
  },
  searchClinicBox: {
    maxWidth: "350px",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 2,
  },
  cardStack: {
    maxWidth: "100%",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  noAppointmentsText: {
    overflowX: "hidden",
    width: "100%",
    maxWidth: "100%",
    borderRadius: 2,
    my: "0.5rem",
    py: 0,
    textAlign: "left",
    mb: 1,
  },
};
